import React from 'react';
import { motion } from 'framer-motion';
import { StarAward, Lightning, SpeechBubbles } from './Icons';
interface WhySimonProps {
  lang: 'en' | 'es';
}
export const WhySimon: React.FC<WhySimonProps> = ({
  lang
}) => {
  const content = {
    en: {
      badges: [{
        icon: StarAward,
        title: 'Any Make & Model',
        desc: 'Access to every brand on the market'
      }, {
        icon: Lightning,
        title: 'Fast & Hassle-Free',
        desc: 'Simple process from first contact to keys in hand'
      }, {
        icon: SpeechBubbles,
        title: 'Bilingual Service',
        desc: 'English & Spanish — we speak your language'
      }],
      footer: 'Hundreds of happy clients across South Florida · All brands · All budgets'
    },
    es: {
      badges: [{
        icon: StarAward,
        title: 'Cualquier Marca',
        desc: 'Acceso a todas las marcas del mercado'
      }, {
        icon: Lightning,
        title: 'Rápido y Sin Complicaciones',
        desc: 'Del primer contacto a las llaves en tus manos'
      }, {
        icon: SpeechBubbles,
        title: 'Atención Bilingüe',
        desc: 'Inglés y Español — hablamos tu idioma'
      }],
      footer: 'Cientos de clientes satisfechos en el Sur de Florida · Todas las marcas · Todos los presupuestos'
    }
  };
  const t = content[lang];
  return <section className="py-20 px-6 bg-background" data-id="element-162">
      <div className="max-w-6xl mx-auto" data-id="element-163">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-164">
          {t.badges.map((badge, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-card border border-border rounded-xl p-6 flex items-center gap-5" data-id="element-165">
              <div className="w-12 h-12 shrink-0 rounded-full bg-secondary/10 flex items-center justify-center text-secondary" data-id="element-166">
                <badge.icon size={24} data-id="element-167" />
              </div>
              <div data-id="element-168">
                <h4 className="font-semibold text-white mb-1" data-id="element-169">{badge.title}</h4>
                <p className="text-sm text-[#aaaaaa]" data-id="element-170">{badge.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center text-[#888888] text-sm font-medium tracking-wide" data-id="element-171">
          {t.footer}
        </motion.p>
      </div>
    </section>;
};